import { AxiosResponse } from 'axios';

export class AxiosResponseHelper {
  public static IsSuccessfulResponse = (response: AxiosResponse) => {
    return response && [200, 204].some((value) => response.status === value);
  };
}
